import * as t from 'io-ts'
// We need this import to force parcel to build the third translations file.
const enOverrides = import('./translations-en.samoon.json')
const enBase = import('./translations-en.json')
const fr = import('./translations-fr.json')
import type EN from './translations-en.json'

export type MessageID = keyof typeof EN
export type Messages = { [K in keyof typeof EN]: string }

const en = Promise.all([enBase, enOverrides.catch(() => ({}))]).then(
  ([enBase, enOverrides]) => ({ ...enBase, ...enOverrides })
)

const data = Promise.all([en, fr]).then(([en, fr]) => ({ en, fr }))

export const Locale = t.keyof({ en, fr })
export type Locale = t.TypeOf<typeof Locale>

export const locales: Locale[] = ['en', 'fr']
// old version of translatedMessage
// export const translatedMessage = (locale: Locale) => (id: MessageID) => data[locale][id]
export default data
